import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import jwt_decode from 'jwt-decode';

// @ts-ignore
import NProgress from 'nprogress';
NProgress.configure({
  showSpinner: false, 
  //template: '<div id="overlay"><div class="bar" role="bar"><div class="peg"></div></div></div>',
  template: '<div class="bar" role="bar"><div class="peg"></div></div>',
});

import BootstrapVue from 'bootstrap-vue';
Vue.use(BootstrapVue);

import axios from 'axios';
import VueAxios from 'vue-axios';
import { ResponseCodeEnum } from '@/models';
import { loginService, toastService } from './services';
axios.interceptors.request.use((config) => {
  // Do something before request is sent
  //check fist time login
  if(localStorage['x-auth-token']){
    const decoded: any = jwt_decode(localStorage['x-auth-token']);
    if (!decoded.isLogin) {
      router.push({ name: 'router.reset_first_password' });
    }
  }
  NProgress.start();
  return loginService.addToken(config);
}, (error) => {
  // Do something with request error
  NProgress.done();
  return Promise.reject(error);
});
axios.interceptors.response.use((res) => {
  NProgress.done();
  if (res.data.code
    && res.data.code !== ResponseCodeEnum.CODE_SUCCESS
    && res.data.code !== ResponseCodeEnum.CODE_BUSINESS) {
    // Show error
    toastService.error(res.data.code);
  } else if (res.data.code && res.data.code === ResponseCodeEnum.CODE_BUSINESS) {
    // Show business error
    toastService.error(ResponseCodeEnum.CODE_BUSINESS, res.data.data);
  } else if (res.data.code && res.data.code === ResponseCodeEnum.CODE_EXPIRED) {
    // Logout
    toastService.error(ResponseCodeEnum.CODE_EXPIRED, res.data.data);
    loginService.logout();
    router.push({ name: 'routes.login' });
  } else if (res.data.code && res.data.code === ResponseCodeEnum.CODE_INTERNAL_ERROR) {
    // Show internal error
    toastService.error(ResponseCodeEnum.CODE_INTERNAL_ERROR, res.data.data);
  }
  return res;
}, (error) => {
  NProgress.done();
  // Do something with response error
  if (error.response && error.response.status) {
    if (error.response.status !== 400 && error.response.status !== 401) {
      toastService.errorMessage(error.response.data.error);
    } else if (error.response.status === 401) {
      // Logout
      toastService.error(ResponseCodeEnum.CODE_EXPIRED);
      loginService.logout();
      router.push({ name: 'routes.login' });
    }
  } else {
    toastService.errorMessage(error.message);
  }
  return Promise.reject(error);
});
Vue.use(VueAxios, axios);

import VueI18n from 'vue-i18n';
import i18n from './langs/i18n';
Vue.use(VueI18n);

import moment from 'moment-timezone';
moment.locale(i18n.locale);
moment.tz.setDefault('UTC');
Vue.prototype.$moment = moment;

import Toasted from 'vue-toasted';
Vue.use(Toasted, {
  position: 'bottom-right',
  duration: 5000,
  singleton: true,
  // theme: 'outline'
});

// @ts-ignore
import VueSignaturePad from 'vue-signature-pad';
Vue.use(VueSignaturePad);

// @ts-ignore
import VueQrcodeReader from 'vue-qrcode-reader';
Vue.use(VueQrcodeReader);

// @ts-ignore
import gallery from 'vue-gallery-viewer';
Vue.use(gallery);

Vue.config.productionTip = false;
declare module 'vue/types/vue' {
  interface Vue {
    $moment: any,
  }
}

const mainApp = new Vue({
  router,
  store,
  i18n,
  render: (h) => h(App),
}).$mount('#app');
export default mainApp;
